import { List, Skeleton } from "antd";
import { genArray } from "Explore/Utils/ArrayGenerator";
import React, { useState } from "react";

const LoadingListEntityProfile = ({
  isLoading,
  data,
  Element,
  componentNum,
  grid = { gutter: 10, column: 1 },
  rows = 2,
  avatar = true,
}) => {
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 10,
    total: 0,
  });
  return isLoading ? (
    <List
      grid={grid}
      dataSource={genArray(componentNum)}
      renderItem={(index) => {
        return (
          <List.Item key={index}>
            <Skeleton
              avatar={avatar}
              paragraph={{
                rows: rows,
              }}
              active
            />
          </List.Item>
        );
      }}
    />
  ) : (
    <List
      grid={grid}
      dataSource={data}
      renderItem={(item, index) => {
        return (
          <List.Item key={index}>
            <Element item={item} />
          </List.Item>
        );
      }}
      pagination={pagination}
    />
  );
};

export default LoadingListEntityProfile;
